module.exports = __webpack_public_path__ + "static/desktop/img/simple.4436d83f.jpg";